<script setup lang="ts">
import ApplicationLogo from "@/Components/ApplicationLogo.vue";
</script>
<template>
  <div class="flex flex-row">
    <ApplicationLogo />
    <span
      v-if="$page?.props?.name"
      class="flex text-sm leading-6 pl-2"
    >{{ $page.props.name }} by besapro.eu</span>
    <span
      v-else
      class="flex text-sm leading-6 pl-2"
    >besapro.eu</span>
  </div>
</template>
